<template lang="pug">
  v-container(fluid)
    //- detail dialog
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog'  :request='currentRequest' @close="detailsDialog=false;" admin="purchase")
    //- content
    v-card.purchases-provider-dialog
      v-card-title.dialog-card-title(style="height: 60px !important")
          p Compras provedor - {{provider.name}}
          v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
      v-card-text.body-1.mt-2
        v-row.mt-3
          //- Select shop
          v-col.py-0(cols="12" xs="12" sm="6" md="6")
            v-select.rounded-xl(
                :label="$t('purchases.filter_by_store')",
                elevation=0
                outlined
                :items='field.locations || []',
                v-model='currentLocation',
                item-text='full_name',
                return-object, dense='', solo='',
                clearable='', @input='selectShop',
                @click:clear='clearShopSelection')
                  template(v-if='data.item' slot='selection', slot-scope='data')
                    v-flex(xs2='')
                      v-avatar(size='25px')
                        img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    v-flex.ml-1(style='font-size:10px; color :#000;')
                      | {{ data.item.name }}
                  template(v-if='data.item' slot='item', slot-scope='data' )
                    v-row.my-1
                      v-avatar
                        img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                      b {{data.item.name}}
          v-col.d-flex.justify-end.px-0.py-0(cols="12" xs="12" sm="6" md="6")
            v-btn.main-btn-gradient(small color='#3cbbc2' style="height: 48px;" @click="onexport()" :disabled="filteredTransactions.length == 0")
              v-icon mdi-arrow-collapse-down
              | Exportar
            v-menu(v-model='menu', :close-on-content-click='false' offset-y='')
              template(v-slot:activator='{ on }')
                v-btn.main-btn-gradient(color='#3cbbc2', dark small v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  p filtrar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="fetch(false, $event)" :currentType='currentType',)
        //- Content
        v-row.px-2.my-2
          MovementTransactions(
            title="Movimientos compras"
            :movements="transactionTotals.qty.toString()"
            :total="transactionTotals.total.toFixed(2)"
            utility=""
          )
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              //- Desktop
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="filteredTransactions.slice(10*(page-1), 10*(page)) || []" show-expand hide-default-footer)
                  template( v-slot:item="props" )
                    tr(@click="props.item.items ? openDetail(props.item) : '' " :style="props.item.items ? 'cursor: pointer;' : ''")
                      td.text-xs-left
                        .datatable-cell-wrapper {{ props.item.reference_number }}
                      td.text-xs-left(hidden)
                        | {{props.item.items}}
                      td
                        span(v-for="product of props.item.items")
                          p {{product.name}} ({{product.amount}})
                      td.text-xs-left
                        .datatable-cell-wrapper  {{ props.item.time | moment }}
                      td.text-xs-left.red--text(v-if="props.item.isCanceled || !props.item.items") Anulada
                      td.text-xs-left(v-else :style='getstatus(props.item.items) === "completed" ? "color: green":"color: #fb8c00"')
                        .datatable-cell-wrapper  {{getstatus(props.item.items) | translateStatus}}
                      td.text-xs-left()
                        .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
                      td.text-xs-left(v-if="props.item.type !=='transfers'")
                        .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                v-pagination.my-4(v-model="page" :length="pageNumber" :total-visible="11")
              //- Mobile
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group(style="width: 100%;")
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                      template(v-slot:default="{ active, toggle }")
                        v-list-item-content(@click="item.items ? openDetail(item) : '' ")
                          p.font-weight-bold # {{item.reference_number}}
                          p.mt-2 {{item.provider ? item.provider : ''}}
                          p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                          p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                          p(v-if="item.isCanceled || !item.items").red--text Anulada
                          p.mt-2(v-else) {{getstatus(item.items) | translateStatus}}
                          p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                      v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes compras", description="Puedes ver tus compras en otro rango de fechas")
</template>

<script>
  import XLSX from 'xlsx'
  import moment from 'moment'
  export default {
    components: {
      DateFilter: () => import('@/components/custom/filters/DateFilter'),
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      NoResults: () => import('@/components/custom/NoResults'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      moment: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'completed':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
    },
    props: {
      provider: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        menu: false,
        currentType: '',
        loading: false,
        currentLocation: null,
        selectedDate: null,
        dateFrom: '',
        dateTo: '',
        page: 1,
        currentRequest: '',
        detailsDialog: false,
        transactionTotals: {
          qty: 0,
          revenue: 0,
          total: 0,
        },
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      headers () {
        return [
          {
            sortable: false,
            text: '# de referencia',
            value: 'type',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.products'),
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.time'),
            value: 'time',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.status'),
            value: 'status',
            align: 'left',
          },
          {
            sortable: false,
            text: this.$t('purchases.table_headers.destination'),
            value: 'location_to.name',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.total'),
            value: 'total',
            align: 'left',
          },
          {
            text: '',
            value: 'data-table-expand',
          },
        ]
      },
      purchases () {
        return this.$store.getters['transactions/getPurchases']
      },
      transactions () {
        const vm = this
        if (!!vm.currentLocation && !!vm.purchases) {
          return vm.purchases.filter((el) => {
            if (el.location_to.id === vm.currentLocation.id) {
              // console.log(el.location_to.id, vm.currentLocation.id)
              return true
            }
          })
        } else if (vm.purchases) {
          return vm.purchases
        } else {
          return vm.purchases
        }
      },
      pageNumber () {
        if (!this.transactions || this.transactions.length === 0) return 0
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        if (!this.transactions || this.transactions.length === 0) return []
        return this.transactions
      },
    },
    watch: {
      page (val, oldVal) {
        const vm = this
        if (val >= vm.pageNumber - 1) {
          vm.getNextPages()
        }
      },
    },
    created () {
      this.fetch()
    },
    methods: {
      selectShop (item) {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', item)
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null)
      },
      fetch (initial = true, dates = null) {
        const vm = this
        vm.menu = false
        vm.loading = true
        vm.selectedDate = dates
        if (initial) {
          vm.dateFrom = vm.$moment().format('YYYY-MM-DD')
          vm.dateTo = vm.$moment(vm.dateFrom).add(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(vm.dateFrom, vm.dateTo)
        } else {
          vm.dateFrom = moment(dates.from).format('YYYY-MM-DD')
          vm.dateTo = moment(dates.to).subtract(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(vm.dateFrom, vm.dateTo)
        }
      },
      loadLog (dateFrom, dateTo) {
        const vm = this
        vm.page = 1
        vm.$store.dispatch('transactions/loadLogTotals', { type: 'purchases', from: dateFrom, to: dateTo, provider: vm.provider.name }).then(function (res) {
          vm.transactionTotals = { ...res }
          vm.loading = false
        })
        vm.$store.dispatch('transactions/loadLog', ['purchases', dateFrom, dateTo, false, vm.provider.name]).then(function () {
          vm.loading = false
        })
      },
      getstatus (items) {
        const found = items.find(element => element.status === 'pending')
        if (found) {
          return 'pending'
        } else {
          return 'completed'
        }
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
      onexport () {
        const vm = this
        const products = []
        vm.transactions.forEach(element => {
          // console.log(element)
          const item = {}
          item.referencia = element.reference_number.toString()
          item.tipo = element.type
          item.productos = vm.productsInOrderExcel(element.items, true)
          item.fecha = vm.$moment(element.time).format('DD/MM/YYYY hh:mm:ss a')
          item.estado = vm.getstatus(element.items)
          item.proveedor = element.provider
          item.punto = element.location_to.name
          item.total = element.total
          products.push(item)
        })
        const date = (moment().format('YYYY-MM-DD')).split('-')
        const dateFormated = date[2] + '/' + date[1] + '/' + date[0]
        const fileName = 'compras_' + dateFormated
        const xls = XLSX.utils.json_to_sheet(products)
        const wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, xls, 'productos') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      productsInOrderExcel (products) {
        // span(v-for='product in props.item.items') {{product.name}},
        let productsString = ''
        if (products) {
          products.forEach((product, index) => {
            if (index !== products.length - 1) {
              productsString += '(' + product.amount + ') ' + product.name + ', '
            } else {
              productsString += '(' + product.amount + ') ' + product.name
            }
          })
          return productsString
        } else {
          return 'Esta compra no tiene productos'
        }
      },
      getNextPages () {
        const vm = this
        if (!vm.transactions || vm.transactions.length === 0) return
        const index = vm.transactions.length
        vm.loading = true
        const bodyQuery = {
          type: 'purchases',
          from: vm.dateFrom,
          to: vm.transactions[index - 1].time,
          provider: vm.provider.name,
        }
        vm.$store.dispatch('transactions/loadLogPagination', bodyQuery).then(function (res) {
          vm.loading = false
        })
      },
    },
  }
</script>

<style lang='scss' scoped>
  .purchases-provider-dialog{
    .card-transactions{
      height: 350px;
      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    @media(min-width: 760px) {
      .show-table-mobile{
        display: none !important;
      }
      .show-table-desktop{
        display: block !important;
      }
    }
    @media(max-width: 1100px) {
      .show-table-mobile{
        display: flex !important;
      }
      .show-table-desktop{
        display: none !important;
      }
    }
  }
</style>
